var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ix-form-input-small-options',{attrs:{"value":_vm.value,"item-key":"value","item-value":"value","item-text":"text","is-editable":!_vm.disabled,"options":_setup.stakeholderItems},on:{"input":(val) => _setup.emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }